export default __webpack_public_path__ + "static/media/top-footer-3.da3b7c4a.png";